import React, { useEffect, useState } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { PageWrapper, H1WithBack, Flex, ContentWrapper } from 'styling/GlobalStyles'
import { TaskOperationTab } from './TaskTOperationTab'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  addLogic,
  clearTaskTemplate,
  editTaskTemplate,
  getSingleTaskTemplate,
} from 'features/taskTemplates/taskTemplatesSlice'
import { toast } from 'react-toastify'
import { AppDispatch, RootState } from 'store'
import { TaskComponentsTab } from './TaskComponentsTab'
import { TaskTWorkUnitTab } from './TaskTWorkUnitTab'
import { DropDownTabsContainer } from 'components/DropDownTabsContainer/DropDownTabsContainer'
import { ITaskTemplateState, ITaskTemplateStateComponent } from 'types/task-templates.interface'
import { taskTemplatesInitialState } from './taskData'
import { TaskTLogicTab } from './TaskTLogicTab'
import { TaskTDesignTab } from './TaskTDesignTab'
import { TaskTMachinesTab } from './TaskTMachinesTab'
import { TaskTAllowedRolesTab } from './TaskTAllowedRolesTab'
import { TaskTFallBackRolesTab } from './TaskTFallbackRoles'

export const EditTaskTemplate = () => {
  const [active, setActive] = useState('Operation')
  const { id } = useParams()
  const dispatch = useDispatch<AppDispatch>()
  const { singleTaskTemplate } = useSelector((store: RootState) => store.taskTemplates)
  const [state, setState] = useState<ITaskTemplateState>(taskTemplatesInitialState)
  const [initialComponents, setInitialCompoents] = useState([])
  const [isHydratedFromStore, setIsHydratedFromStore] = useState(false)
  const navigate = useNavigate()
  const location = useLocation();

  useEffect(() => {

    if (location.pathname.includes('logic')) {
      setActive('Logic')
    }
  }, [location.pathname]);

  useEffect(() => {
    dispatch(getSingleTaskTemplate(parseInt(id)))
    return () => {
      dispatch(clearTaskTemplate())
    }
  }, [])

  useEffect(() => {
    if (singleTaskTemplate && !isHydratedFromStore) {
      setState(singleTaskTemplate)
      setInitialCompoents(singleTaskTemplate.components)
      setIsHydratedFromStore(true)
    }
  }, [singleTaskTemplate, isHydratedFromStore])

  const handleSubmit = async () => {
    if (!state.operation?.id) {
      toast.warn('Task capability must be selected.')
      return
    }
    if (state.components.some((c) => !c.componentType)) {
      toast.warn('Components must have set component type.')
      return
    }

    if (!state.requiredMachineCategory?.value) {
      toast.warn('Required machinecategory must be selected.')
      return
    }

    if (state.toolTypeComponents.some((t) => !t.name)) {
      toast.warn('Tool type components must have set name.')
      return
    }
    const found = state.toolTypeComponents.find(c => c.component.value == 2)

    if (found && !found.unit?.value) {
      toast.warn('Please select item unit.')
      return
    }

    dispatch(editTaskTemplate({ ...state, id: Number(id) })).then(r => {

      if (r.meta.requestStatus === 'fulfilled') {
        setInitialCompoents(state.components)
        navigate('/configurations/task-templates/' + id + '/edit/logic', { replace: true })
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
      } else if (r.error) {
        return toast.error('An error occured, check your configuration and try again.')
      }
    })
  }

  const handleLogicSubmit = async (functionType: number) => {
    if ((state.components as ITaskTemplateStateComponent[]).some(c => c.componentType == 2 && !c.functionId)) {
      toast.warn('All calculated compoonents must be connected to functions')
      return
    }
    await dispatch(addLogic({ functionType, components: state.components.filter(c => c.componentType == 2), id }))
  }



  const renderTabs = () => {
    switch (active) {
      case 'Logic':
        return (
          <TaskTLogicTab
            state={state}
            setState={setState}
            handleLogicSubmit={handleLogicSubmit}
          />
        )
      case 'Operation':
        return <TaskOperationTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Allowed Roles':
        return <TaskTAllowedRolesTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Fallback Roles':
        return <TaskTFallBackRolesTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Design':
        return <TaskTDesignTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Components':
        return <TaskComponentsTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Machine Category':
        return <TaskTMachinesTab state={state} setState={setState} handleSubmit={handleSubmit} />
      case 'Work Unit Amounts':
        return <TaskTWorkUnitTab state={state} setState={setState} handleSubmit={handleSubmit} />
      default:
        return <TaskOperationTab state={state} setState={setState} handleSubmit={handleSubmit} />
    }
  }

  const handleLogicTab = () => {
    if (JSON.stringify(state.components) === JSON.stringify(initialComponents)) {
      setActive('Logic')
    } else {
      toast.warn('Please save the task first')
    }
  }

  return (
    <div>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between center mb='16'>
          <H1WithBack arrow title={'Edit ' + (state.name ? state.name : '')} />
          <DropDownTabsContainer
            tabs={['Operation', 'Allowed Roles', 'Fallback Roles', 'Design', 'Components', 'Machine Category', 'Logic', 'Work Unit Amounts']}
            setActive={setActive}
            customHandleClick={{ fn: handleLogicTab, tab: 'Logic' }}
            active={active}
          />
        </Flex>
        <ContentWrapper>{renderTabs()}</ContentWrapper>
      </PageWrapper>
    </div>
  )
}
